import { type Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'opportunities', pathMatch: 'full' },
      {
        path: 'knowledge',
        loadChildren: () =>
          import('./features/knowledge/knowledge.routes').then((m) => m.KNOWLEDGE_ROUTES),
      },
      {
        path: 'assets',
        loadChildren: () => import('./features/assets/assets.routes').then((m) => m.ASSETS_ROUTES),
      },
      {
        path: 'opportunities',
        loadChildren: () =>
          import('./features/opportunities/opportunities.routes').then(
            (m) => m.OPPORTUNITIES_ROUTES,
          ),
      },
      {
        path: 'feedback',
        loadChildren: () =>
          import('./features/feedback/feedback.routes').then((m) => m.FEEDBACK_ROUTES),
      },
      {
        path: 'accounts',
        loadChildren: () =>
          import('./features/accounts/accounts.routes').then((m) => m.ACCOUNTS_ROUTES),
      },
      { path: '**', redirectTo: 'opportunities' },
    ],
  },
];
